module.exports = __webpack_public_path__ + "img/hitotoki.b4b9c3d.png";